export default __webpack_public_path__ + "locales/fi/OAuth.json?hash=f5ccdb820cb73c73bcfded576062c572";